<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <!-- eslint-disable-next-line max-len -->
      <v-tab v-for="tab of tabs" class="common-font-size" :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <span>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';
import '../assets/style.css';

export default {
  name: 'TaxInquiry',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName();
    this.loadDropDownList();
  },
  updated() {
    this.getPathName();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/taxinquiry/taxrollsearch' }, caption: 'Tax Roll' },
      { id: 2, to: { path: '/tax/taxinquiry/ownersearch' }, caption: 'Owner Search' },
      { id: 3, to: { path: '/tax/taxinquiry/mobile-home' }, caption: 'Mobile Home' },
      { id: 4, to: { path: '/tax/taxinquiry/reports' }, caption: 'Reports' },
    ],
  }),
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('tax/taxPayment', [
      'loadPaymentsWkstList',
    ]),
    loadDropDownList() {
      this.setCriteria(['ownerTransactionList', {}]);
      this.setCriteria(['TaxrollTransactionList', {}]);
      this.setCriteria(['taxMobile', {}]);
      const criteria = { limit: 100, skip: 0 };
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.loadTaxMortgageCodesSharedRecords(
        {
          criteria: {
            ...criteria,
            sortBy: [{
              column: 'mtgCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessMTGData,
          isItSetState: true,
        },
      );
      this.loadTaxStatusCodesSharedRecords(
        {
          criteria: {
            sortBy: [{
              column: 'statusCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessStatusCodesData,
          isItSetState: true,
        },
      );
      this.loadTaxStatusCodesSharedRecords(
        {
          criteria: {
            // was: highlightTaxRecord: true
            // Widened to highlight OR alert so the one fetch also carries the codes flagged
            // "Alert on tax record" (which need not be highlighted). Alert-only codes come
            // back with no highlightColor, and the grid colour maps already skip falsy
            // colours - so search grid row colouring is unchanged.
            highlightOrAlertOnTaxRecord: true,
          },
          baseCrudKey: 'taxStatusCodesSharedHighlight',
        },
      );
      this.loadTaxAdditionsRecords(
        {
          criteria: {
            limit: 50,
            skip: 0,
            sortBy: [{
              column: 'additionCode',
              direction: 'asc',
            }],
          },
          postProcessTrans: this.postProccessAdditionsData,
          isItSetState: true,
        },
      );
      this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
      this.loadtaxAdjTypesSharedRecords({
        criteria: {},
        postProcessTrans: this.postProccessAdjTypesData,
        baseCrudKey: 'taxAdjTypesList',
      });
      this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
        postProcessTrans: this.postProccessTaxFeeData,
        baseCrudKey: 'sharedTaxFeeMaster',
      });
      this.loadCommentTypes({
        criteria: { sortBy: [{ column: 'commentCode', direction: 'asc' }] },
        postProcessTrans: this.postProccessCommentsCategoryData,
        baseCrudKey: 'sharedTaxComments',
      });
      this.loadPaymentsWkstList();
      this.$store.dispatch('UserAdministration/loadUsers');
    },
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      if (ftr.length) this.activetab = ftr[0].id - 1;
      else if (curPath.includes('utils')) this.activetab = 5;
      else this.activetab = 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },
};
</script>
